module.exports = __webpack_public_path__ + "static/img/insurance-other.c520578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-other.jpg
// module id = 50dQ
// module chunks = 4